import Service, { service } from '@ember/service';
import type FetchService from '@triptyk/ember-utils/services/fetch';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type IntlService from 'ember-intl/services/intl';
import type CurrentUserService from '../current-user';
import { ContactChangeset } from 'frontend/changesets/contact';

/* jscpd:ignore-start */
export default class ContactChangesetService extends Service {
  @service declare fetch: FetchService;
  @service declare flashMessages: FlashMessageService;
  @service declare intl: IntlService;
  @service declare currentUser: CurrentUserService;

  emptyChangeset() {
    return new ContactChangeset({
      lastName: '',
      firstName: '',
      email: '',
      message: '',
    });
  }

  async sendContact(changeset: ContactChangeset) {
    changeset.execute();
    const changesetData = changeset.data;

    const body = {
      lastName: changesetData.lastName,
      firstName: changesetData.firstName,
      email: changesetData.email,
      message: changesetData.message,
    };

    try {
      await this.fetch.request('contact/info', {
        method: 'POST',
        body: JSON.stringify(body),
      });
      this.flashMessages.success(
        this.intl.t(
          'components.pages.dashboard.formation.contact.send_mail.success'
        )
      );
    } catch (e) {
      this.flashMessages.alert(
        this.intl.t(
          'components.pages.dashboard.formation.contact.send_mail.failed'
        )
      );
    }
  }
}
/* jscpd:ignore-end */

declare module '@ember/service' {
  interface Registry {
    'changesets/contact': ContactChangesetService;
  }
}
